import apiAgent from "../../../api/apiAgent";

export const useFileDownload = () => {
  const downloadFile = async (fileId: string, fileName: string) => {
    try {
      const response = await apiAgent.Library.fsDownloadFileAjax(fileId);
      const blob = new Blob([response.data], { type: response.headers["content-type"] });
      const downloadUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");

      a.href = downloadUrl;
      a.download = fileName;

      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      console.error("Failed to download file:", error);
    }
  };

  return { downloadFile };
};
